export enum PaginationMode {
    Server = 'server',
    Client = 'client',
}
